import { Suspense } from 'react';

import { hasProduction } from '@/helpers/customerUtils';
import Redirect from '@/pages/Redirect';
import { find } from 'lodash';
import ProgressLoading from 'ui/components/ProgressLoading';
import { RouteComponents } from './RouteComponents';
import { RouteType } from './types';
import { Box } from 'ui/mui';

const RouteChecker = (route: RouteType, routes: RouteType[], props: any) => {
  if (route.redirect) {
    return <Redirect to={route.redirect} />;
  }

  const Component = route.component ? RouteComponents[route.component] : null;

  if (!Component) {
    return null;
  }

  const parentRoute = find(
    routes,
    (r) => r.path === `/${route.path.split('/')[1]}`,
  );

  const infraService = route.infraService
    ? props.selectedProperty.infraServices.find(
        (utility: any) =>
          utility.name === route.infraService ||
          (route.infraService === 'ELPROD' && hasProduction(utility)),
      )
    : parentRoute?.infraService
      ? props.selectedProperty.infraServices.find(
          (utility: any) =>
            utility.name === parentRoute.infraService ||
            (parentRoute.infraService === 'ELPROD' && hasProduction(utility)),
        )
      : null;

  return (
    <Suspense
      fallback={
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
        >
          <ProgressLoading />
        </Box>
      }
    >
      <Component
        key={infraService?.id || route.path}
        infraService={infraService}
        route={route}
        isProduction={route.infraService === 'ELPROD'}
        {...props}
      />
    </Suspense>
  );
};

export default RouteChecker;
